import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    input,
    inject,
    computed,
} from '@angular/core';
import { BazisConfigurationService, VEHICLE_MASK_SETTINGS } from '@bazis/configuration.service';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'bazis-vehicle-number',
    templateUrl: './vehicle-number.component.html',
    imports: [CommonModule, TranslocoModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleNumberComponent implements OnDestroy {
    public configurationService = inject(BazisConfigurationService);

    readonly vehicleNumber = input<string>(undefined);

    readonly maskSettings = input(VEHICLE_MASK_SETTINGS);

    readonly regionSuffix = input<string>('rus');

    parts = computed(() => {
        let end = 0;
        let group = this.configurationService.vehicleNumberMask;
        if ('vehicleNumberDisplay' in this.configurationService) {
            group = this.configurationService.vehicleNumberDisplay;
        }
        return group.map((maskGroup) => {
            const start = end;
            const maxEnd = start + maskGroup.length;

            let currentValue = '';

            let maxValue = (this.vehicleNumber() || '')
                .substring(start, maxEnd)
                .toUpperCase()
                .split('');
            maskGroup.split('').forEach((maskSymbol, indexMaskSymbol) => {
                if (maxValue.length < indexMaskSymbol) return;

                if (
                    this.maskSettings().patterns[maskSymbol].pattern.test(maxValue[indexMaskSymbol])
                ) {
                    currentValue += maxValue[indexMaskSymbol];
                }
            });

            end += currentValue.length;

            return currentValue.toUpperCase();
        });
    });

    ngOnDestroy(): void {}
}
